import { render, staticRenderFns } from "./ChatBoxTextButton.vue?vue&type=template&id=314e9e39&scoped=true&"
import script from "./ChatBoxTextButton.vue?vue&type=script&lang=js&"
export * from "./ChatBoxTextButton.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxTextButton.vue?vue&type=style&index=0&id=314e9e39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314e9e39",
  null
  
)

export default component.exports